import * as React from "react";

import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { FilesCategoryEnum } from "src/services/Enum/FilesCategoryEnum";
import { FileVersionEnum } from "src/services/Enum/FileVersionEnum";
import DownloadFileButton from "src/components/common/GenericButtons/DownloadFileButton/DownloadFileButton";
import { contato } from "src/util/constants";
import { Col, Row } from "antd";

export default function FAQPage() {
    const mailTo = `mailto:${contato.email_support}`;

    return (
        <PbrCard className="default-tabs" title={"FAQ & Dúvidas"} bordered={false} style={{ width: "100%" }}>
            <>
                <Row gutter={16}>
                    <p>Clique no botão abaixo para baixar as instruções de utilização da plataforma</p>
                    <Col xs={24} sm={24} md={24} lg={8} style={{ marginTop: "15px" }}>
                        <DownloadFileButton category={FilesCategoryEnum.OFFICER_INSTRUCTIONS} version={FileVersionEnum.NONE} extension="pdf" />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <p style={{ marginTop: "20px" }}>Para outras dúvidas entre em contato pelo e-mail <a href={mailTo}>{contato.email_support}</a></p>
                </Row>
            </>
        </PbrCard>
    );
}




// WEBPACK FOOTER //
// ./src/pages/help/faq/faq.page.tsx